/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UndoCheckOutInput = {
    bookingId: string;
};
export type UndoCheckOutMutationVariables = {
    input: UndoCheckOutInput;
};
export type UndoCheckOutMutationResponse = {
    readonly UndoCheckOutMutation: boolean;
};
export type UndoCheckOutMutation = {
    readonly response: UndoCheckOutMutationResponse;
    readonly variables: UndoCheckOutMutationVariables;
};



/*
mutation UndoCheckOutMutation(
  $input: UndoCheckOutInput!
) {
  UndoCheckOutMutation(input: $input)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "UndoCheckOutMutation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UndoCheckOutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UndoCheckOutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e6eb9e914d6f63576cfa5a678f33e74",
    "id": null,
    "metadata": {},
    "name": "UndoCheckOutMutation",
    "operationKind": "mutation",
    "text": "mutation UndoCheckOutMutation(\n  $input: UndoCheckOutInput!\n) {\n  UndoCheckOutMutation(input: $input)\n}\n"
  }
};
})();
(node as any).hash = 'd8885d015e746ab78979d4ac9ff71f45';
export default node;
